var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoritesFilled = function SvgFavoritesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.201.814A6.5 6.5 0 0 0 17.04 0c-2.026 0-3.84.923-5.037 2.372A6.54 6.54 0 0 0 3.798.814 6.55 6.55 0 0 0 .414 6.551c0 .707.115 1.385.323 2.02 1.124 5.051 11.265 11.422 11.265 11.422s10.134-6.37 11.26-11.423a6.5 6.5 0 0 0 .324-2.019A6.56 6.56 0 0 0 20.2.814"
  })));
};
export default SvgFavoritesFilled;